import FormStyleEditorFormFieldsPanel from './FormStyleEditorFormFieldsPanel';

export default FormStyleEditorFormFieldsPanel;
